import { defineMessage } from 'services/localization';

export const messages = {
    accountCurrency: defineMessage('account_currency_1'),
    accountName: defineMessage('account_name_1'),
    accountNumber: defineMessage('account_number_1'),
    iban: defineMessage('iban_1'),
    swiftCode: defineMessage('swift_code_1'),
    bankCountryCode: defineMessage('bank_country_code'),
    bankName: defineMessage('bank_name'),
    bankBranch: defineMessage('bank_branch'),
    localClearingSystem: defineMessage('local_clearing_system'),
    accountingRoutingType1: defineMessage('accounting_routing_type'),
    accountingRoutingType2: defineMessage('accounting_routing_type_1'),
    accountingRoutingValue1: defineMessage('accounting_routing_value'),
    accountingRoutingValue2: defineMessage('accounting_routing_value_1'),
    greenText: defineMessage('you_have_paid_this_cont_ges_in_the_bank_details'),
    yellowText: defineMessage('you_are_paying_this_contact_for_the_first_time'),
    redText: defineMessage('you_have_paid_this_cont_nk_details_have_changed'),
    previous: defineMessage('previous'),
    actual: defineMessage('actual'),
};
